import { render, staticRenderFns } from "./SitList.vue?vue&type=template&id=c10ceea6&scoped=true&"
import script from "./SitList.vue?vue&type=script&lang=ts&"
export * from "./SitList.vue?vue&type=script&lang=ts&"
import style0 from "./SitList.vue?vue&type=style&index=0&id=c10ceea6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10ceea6",
  null
  
)

export default component.exports